import { brandColors } from '../Theme';

export const galiaEyebrowSx = {
    fontSize: '0.8125rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase' as const,
    color: brandColors.lavenderDark,
    mb: 1.25,
};

export const galiaHeadlineSx = {
    fontSize: { xs: '2rem', sm: '2.5rem' },
    fontWeight: 700,
    letterSpacing: '-0.03em',
    lineHeight: 1.1,
    color: '#1a1a1a',
};

export const galiaAccentBarSx = {
    width: 48,
    height: 3,
    borderRadius: 1,
    bgcolor: brandColors.lavender,
    mt: 1.5,
    mb: 2.5,
};

export const galiaBodySx = {
    fontSize: '1.05rem',
    lineHeight: 1.55,
    color: 'rgba(26, 26, 26, 0.68)',
};

export const galiaSectionLabelSx = {
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase' as const,
    color: brandColors.lavenderDark,
    mb: 1.25,
};

export const galiaPrimaryButtonSx = {
    minHeight: 52,
    py: 1.5,
    px: 3,
    borderRadius: 3,
    fontSize: '1rem',
    fontWeight: 700,
    textTransform: 'none' as const,
    boxSizing: 'border-box' as const,
    bgcolor: brandColors.footerBlue,
    '&:hover': {
        bgcolor: '#1565c0',
    },
};

export const galiaSecondaryButtonSx = {
    minHeight: 52,
    py: 1.5,
    px: 3,
    borderRadius: 3,
    fontSize: '1rem',
    fontWeight: 700,
    textTransform: 'none' as const,
    boxSizing: 'border-box' as const,
    borderWidth: 2,
    bgcolor: '#fff',
    borderColor: brandColors.lavenderDark,
    color: brandColors.lavenderDark,
    '&:hover': {
        borderWidth: 2,
        bgcolor: 'rgba(128, 121, 154, 0.08)',
        borderColor: brandColors.lavender,
        color: brandColors.lavender,
    },
};

export const galiaNavButtonSx = (active: boolean) => ({
    textTransform: 'none' as const,
    fontWeight: 600,
    borderRadius: 2,
    px: 1.75,
    minHeight: 40,
    ...(active
        ? {
              bgcolor: brandColors.footerBlue,
              color: '#fff',
              '&:hover': { bgcolor: '#1565c0' },
          }
        : {
              color: brandColors.lavenderDark,
              '&:hover': { bgcolor: 'rgba(128, 121, 154, 0.08)' },
          }),
});

export const galiaFieldSx = {
    '& .MuiOutlinedInput-root': {
        borderRadius: 2,
        bgcolor: '#fff',
    },
};
